import script from "./CreateInvitationLinkModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateInvitationLinkModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateInvitationLinkModal.vue?vue&type=style&index=0&id=9cc80d28&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc80d28"]])

export default __exports__